// Upfront confirmation for Cancel/Delete: posted transactions need a reason (journal is reversed, original kept).
import { toast } from 'sonner';

export function askCancel(label, posted) {
  if (!posted) return window.confirm(label) ? {} : null;
  const r = window.prompt(`${label}\n\nThis transaction is posted: its journal will be reversed and the original kept for audit.\nReason (required):`);
  if (r === null) return null;
  if (!r.trim()) {
    toast.error('A reason is required to cancel a posted transaction');
    return null;
  }
  return { reason: r.trim() };
}
